import type { ComponentChildren } from 'preact';

export interface CardProps {
  title?: string | undefined;
  /** Drop the chrome — used by banners and other bleed-to-edge widgets. */
  bare?: boolean;
  children?: ComponentChildren;
}

export function Card({ title, bare = false, children }: CardProps) {
  return (
    <section class={bare ? 'hud-card hud-card--bare' : 'hud-card'}>
      {title && !bare ? <header class="hud-card__header">{title}</header> : null}
      <div class="hud-card__body">{children}</div>
    </section>
  );
}
